import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  LinearProgress,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button,
  Grid,
  Divider
} from "@mui/material";

import { useNavigate } from "react-router";
import AxiosInstance from "../../Services/AxiosInstance";
import { API_ENDPOINTS } from "../../Services/Services";
import Loader from "../../DesignLayout/Loader/Loader";
const UserReport = () => {
  const [users, setUsers] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [filteredUsers, setFilteredUsers] = useState([]);
   const [addUserMode, setAddUserMode] = useState(false);
  const [roleFilter, setRoleFilter] = useState("");
  const [nameFilter, setNameFilter] = useState("");
  const [newUser, setNewUser] = useState({
  userName: "",
    email: "",
    password: "",
    role: 0,
    contact_No:''
  
    });
    const [role,setrole]=useState([])

const navigate=useNavigate();
  useEffect(() => {
    const fetchData = async () => {
     
      try {
        const response = await AxiosInstance.get(API_ENDPOINTS.GET_USER_REPORT);
        const roles=await AxiosInstance.get(`${API_ENDPOINTS.GET_ROLE}`)
setrole(roles.data || [])
        setUsers(response.data || []);
        setFilteredUsers(response.data || []); // Initialize filtered users
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  // Filtering Logic
  useEffect(() => {
    let updatedUsers = [...users];

    if (roleFilter) {
      updatedUsers = updatedUsers.filter((user) => user.role === roleFilter);
    }

    if (nameFilter) {
      updatedUsers = updatedUsers.filter((user) =>
        user.userName.toLowerCase().includes(nameFilter.toLowerCase())
      );
    }

    setFilteredUsers(updatedUsers);
  }, [roleFilter, nameFilter, users]);

  const handleAddUser = async () => {
    setLoading(true);
    try {
      // API Call to add the user
      await AxiosInstance.post(API_ENDPOINTS.ADD_USER, newUser);
      // Success Message
      localStorage.setItem("userrMessage", "User added successfully!");
  
      // Reset modal and reload page after success
      setAddUserMode(false);
      window.location.reload();
    } catch (error) {
      localStorage.setItem("usererrorMessage", "Failed : Duplicate Name or Email");
      setAddUserMode(false);
      window.location.reload();
    } finally {
      setLoading(false);
    }
  };
  

  const renderProgressBar = (total, completed) => {
    const progress = total ? (completed / total) * 100 : 0;
    return (
      <Box sx={{ mt: 1 }}>
        <Typography variant="body2" color="textSecondary">
          {`${total}/${completed}`}
        </Typography>
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{ height: "8px", borderRadius: "4px" }}
        />
      </Box>
    );
  };
 const handleClick = (userId) => {
    navigate("/userdetails", { state: { userId } });
  };

  return (
    <div className="userreport">
      <Loader loading={Loading}/>
      <Box sx={{ mb: 3 }}>
        <Grid container spacing={3}>
          <Grid item md={3} xs={12}>
            <TextField
              label="Search by Name"
              variant="outlined"
              size="small"
              fullWidth
              onChange={(e) => setNameFilter(e.target.value)}
              sx={{ mb: 2 }}
            />
          </Grid>

          <Grid item md={3} xs={12}>
            <FormControl fullWidth size="small" variant="outlined" sx={{ mb: 2 }}>
              <InputLabel>Filter by Role</InputLabel>
              <Select
                value={roleFilter}
                onChange={(e) => setRoleFilter(e.target.value)}
                label="Filter by Role"
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value="Developer">Developer</MenuItem>
                <MenuItem value="Tester">Tester</MenuItem>
                <MenuItem value="TesterHead">Tester Head</MenuItem>
                <MenuItem value="ItHead">IT Head</MenuItem>
                <MenuItem value="StackHolder">Stack Holder</MenuItem>

              </Select>
            </FormControl>
          </Grid>
          <Grid md={6} className="text-end p-3 " xs={12}>
            <Button className="btn btn-primary" onClick={() => setAddUserMode(true)}>Add User</Button>
          </Grid>
        </Grid>
        <Divider />
      </Box>

      <TableContainer component={Paper} elevation={3} sx={{ mt: 3, borderRadius: "8px", overflow: "hidden" }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>
              <TableCell>UserId</TableCell>
              <TableCell>User Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Created Date</TableCell>
              <TableCell>Projects</TableCell>
              <TableCell>Tasks</TableCell>
              <TableCell>Bugs</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredUsers.length > 0 ? (
              filteredUsers.map((user) => (
                <TableRow key={user.userId} onClick={() => handleClick(user.userId)} sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f1f1f1" } }}>
                  <TableCell>{user.userId}</TableCell>
                  <TableCell>{user.userName}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>{user.role}</TableCell>
                  <TableCell>
                    {new Date(user.createdDate).toISOString().split("T")[0]}
                   
                  </TableCell>
                  <TableCell>
                    {renderProgressBar(user.projectCount, Math.floor(user.projectCount * 0))}
                  </TableCell>
                  <TableCell>
                    {renderProgressBar(user.taskCount, Math.floor(user.taskCount * 0))}
                  </TableCell>
                  <TableCell>
                    {renderProgressBar(user.bugCount, Math.floor(user.bugCount * 0.6))}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} sx={{ textAlign: "center", py: 3, fontStyle: "italic", color: "grey.600" }}>
                  No users found with the selected filters.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {addUserMode && (
  <div
    className="modal show d-block"
    tabIndex="-1"
    style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
  >
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Add New User</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setAddUserMode(false)}
          ></button>
        </div>
        <div className="modal-body">
          <div className="mb-3">
            <label className="form-label">Name</label>
            <input
              type="text"
              name="userName"
              value={newUser.userName || ""}
              onChange={(e) =>
                setNewUser({ ...newUser, userName: e.target.value })
              }
              className="form-control text-start"
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              type="email"
              name="email"
              value={newUser.email || ""}
              onChange={(e) =>
                setNewUser({ ...newUser, email: e.target.value })
              }
              className="form-control text-start"
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Role</label>
            <select name="role" id="role" className="border border-1 text-start p-1 rounded form-select" required onChange={(e) =>
                setNewUser({ ...newUser, role: e.target.value })
              }>
              <option value="">Select Role</option>
              {role.map((roles)=>{
                return <option value={roles.id} key={roles.id}>{roles.name}</option>
              })}
            </select>
          </div>
         
          <div className="mb-3 ">
            <label className="form-label">Phone</label>
            <input
              type="number"
              name="contact_No"
              
              value={newUser.contact_No || ""}
              onChange={(e) =>
                setNewUser({ ...newUser, contact_No: e.target.value })
              }
              className="form-control text-start"
            />
          </div>
          <div className="mb-3 ">
            <label className="form-label">Password</label>
            <input
              type="password"
              name="password"
              minLength={8}
              value={newUser.password || ""}
              onChange={(e) =>
                setNewUser({ ...newUser, password: e.target.value })
              }
              className="form-control text-start"
            />
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setAddUserMode(false)}
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleAddUser}
          >
            Save User
          </button>
        </div>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default UserReport;
